const STORAGE_KEY = 'obana-admin-post-login-path';

const AUTH_PATHS = [
  '/login',
  '/sign-up',
  '/otp',
  '/incorrect-otp',
  '/forgotPassword',
  '/reset-password',
  '/confirm-otp',
];

const isSafePath = (path) =>
  typeof path === 'string' &&
  path.startsWith('/') &&
  !path.startsWith('//') &&
  path !== '/' &&
  !AUTH_PATHS.some((authPath) => path === authPath || path.startsWith(`${authPath}?`));

export const rememberPostLoginPath = (path) => {
  if (!isSafePath(path)) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    return;
  }
};

export const takePostLoginPath = () => {
  try {
    const path = window.sessionStorage.getItem(STORAGE_KEY);
    window.sessionStorage.removeItem(STORAGE_KEY);
    return isSafePath(path) ? path : null;
  } catch {
    return null;
  }
};
